import type { IconName } from "../icon";

export enum SegmentedButtonsVariant {
  DEFAULT = "default",
  LARGE = "large",
  ELEVATED = "elevated",
}

export enum SegmentedButtonsOrientation {
  VERTICAL = "vertical",
  HORIZONTAL = "horizontal",
}

export interface SegmentedButtonsProps {
  variant?: SegmentedButtonsVariant;
  orientation?: SegmentedButtonsOrientation;
  buttons: Array<
    Array<{
      icon: IconName;
      hasCurrentColor?: boolean;
      isDisabled?: boolean;
      ariaLabel?: string;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onMouseEnter?: (...args: any[]) => void;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onMouseLeave?: (...args: any[]) => void;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onClick: (...args: any[]) => void;
    }>
  >;
}
